<template>
    <div class="kexie">
        <div class="herder">
            <img class="header-img" src="@/assets/kexie/regen/u4.png" />
        </div>
        <div class="activity-theme">
            <div class="activity-theme-title">
                <img class="activity-theme-bg" src="@/assets/kexie/regen/u5.png" />
                <span class="line"></span>
                <span>活动主题</span>
                <span class="line"></span>
            </div>
            <div class="activity-theme-content">
                <img class="img-left" src="@/assets/kexie/regen/u11.png" />
                <div class="text-content">
                    <!-- <img class="text-content-bg" src="@/assets/kexie/regen/u10.svg" /> -->
                    <h3>“玩转编程日”线上主题活动</h3>
                    <p>为了给广大青少年编程爱好者搭建实践和交流的平台，拓展青少年编程活动覆盖面，中国科协青少年科技中心将于 2020 年 12 月 1 日 -2020 年 12 月 31 日持续开展 “ 玩转编程日 ” 线上主题活动，为广大青少年和参与者提供持续性的学习体验和展示交流机会。</p>
                </div>
            </div>
        </div>
        <div class="activity-introduce">
            <div class="activity-introduce-title">
                <span class="line"></span>
                <span>活动介绍</span>
                <span class="line"></span>
            </div>
            <div class="activity-introduce-content">
                <div class="activity-introduce-content-text">
                    <p>活动内容： “ 玩转编程日 ” 线上主题活动设 Scratch、Python 和智能设计三个项目，全国各地中小学生均可参加不同项目的活动。</p>
                    <p>{{ `活动形式：活动以线上方式进行，活动专题页面： https://roborobo.${institutionConfig.baseDomainName}/playCode。学生可直接通过互联网注册报名参加活动。` }}</p>
                </div>
                <div class="text-content">
                    <div class="text-box">
                        <span class="title">注册报名</span>
                        <!-- <span>2020年12月01日12时 </span>
                        <span>至 12年06月24时</span> -->
                        <span>2020年12月1日至12月6日</span>
                    </div>
                    <img src="@/assets/kexie/regen/u35.svg" />
                    <div class="text-box cultivate">
                        <span class="title">线上培训</span>
                        <!-- <span>Scratch:12月08日18时</span>
                        <span>Python:12月10日18时</span>
                        <span>智能设计:12月15日18时</span> -->
                        <span>2020年12月8日至12月10日</span>
                    </div>
                    <img src="@/assets/kexie/regen/u35.svg" />
                    <div class="text-box cut-off">
                        <span class="title">比赛日期</span>
                        <!-- <span>Scratch:12月31日24时</span>
                        <span>Python:12月31日24时</span>
                        <span>智能设计:12月27日19时</span> -->
                        <span>2020年12月8日至12月31日</span>
                    </div>
                    <img src="@/assets/kexie/regen/u35.svg" />
                    <div class="text-box list">
                        <span class="title">获奖名单公布</span>
                        <span>2021月1月10日</span>
                    </div>
                </div>
                <p class="prompt">注： 具体时间安排请点击下方赛项，进入赛项主页查看详情</p>
            </div>
        </div>
        <div class="activity-contest">
            <div class="activity-contest-title">
                <span class="line"></span>
                <span>设置赛项</span>
                <span class="line"></span>
            </div>
            <div class="activity-contest-content">
                <div class="originality">
                    <h4>创意编程</h4>
                    <div class="originality-card-box">
                        <div class="contest-card">
                            <img class="img" src="@/assets/kexie/regen/u26.svg" />
                            <div class="card-btn-box" @click="goSignUp('161058993861214208')">
                                <span>我要报名</span>
                            </div>
                            <span class="card-type">Scratch编程项目</span>
                        </div>
                        <div class="contest-card">
                            <img class="img" src="@/assets/kexie/regen/u29.svg" />
                            <div class="card-btn-box" @click="goSignUp('161067101098422272')">
                                <span>我要报名</span>
                            </div>
                            <span class="card-type">Python编程项目</span>
                        </div>
                    </div>
                </div>
                <div class="smart">
                    <h4>智能设计</h4>
                    <div class="contest-card">
                        <img class="img" src="@/assets/kexie/regen/u31.svg" />
                        <a href="https://robosim.robotplayer.com/particular/">
                            <div class="card-btn-box">
                                <span>我要报名</span>
                            </div>
                        </a>
                        <span class="card-type">无人驾驶</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div>
                <p>主办单位：中国科协青少年科技中心</p>
                <p>运营维护：全国青少年科技创新服务平台</p>
            </div>
            <div>
                <p>网站备案：京ICP备11018462号-2 京公网安备11010802009524号</p>
                <p>联系我们：robot@xiaoxiaotong.org</p>
            </div>
            <img class="erweima" src="@/assets/kexie/regen/u44.png" />
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        goSignUp(id) {
            this.$router.push({
                name: 'matchDetail',
                query: { id: id }
            });
        }
    },
}
</script>
<style lang="scss">
.kexie {
    width: 100%;
    font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold', 'PingFang SC', sans-serif;
    overflow: hidden;
    .header-img {
        width: 100%;
    }
    .activity-theme {
        position: relative;
        width: 100%;
        min-height: 800px;
        .activity-theme-bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            min-height: 100%;
            opacity: 0.1;
            z-index: -1;
        }
        .activity-theme-title {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 60px 0;
            padding-bottom: 150px;
            span {
                font-size: 32px;
                font-weight: 650;
                color: #333;
                padding: 0 30px;
            }
            span.line {
                width: 200px;
                height: 1.5px;
                background-color: #999;
            }
        }
        .activity-theme-content {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
            width: 100%;
            min-height: 470px;
            .img-left {
                max-width: 350px;
                max-height: 350px;
            }
            .text-content {
                position: relative;
                width: 910px;
                min-height: 470px;
                padding: 20px 115px;
                font-size: 18px;
                letter-spacing: 1.5px;
                color: #FFFFFF;
                line-height: 40px;
                background-image: url(~@/assets/kexie/regen/u10.svg);
                background-repeat: no-repeat;
                background-size: cover;
                h3 {
                    font-weight: 900;
                    font-style: normal;
                    font-size: 24px;
                    color: #FFFFFF;
                    text-align: center;
                    padding-bottom: 50px;
                }
                p {
                    text-indent: 2em;
                }
            }
        }
    }
    .activity-introduce {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        min-height: 800px;
        .activity-introduce-title {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 60px 0;
            span {
                font-size: 32px;
                font-weight: 650;
                color: #333;
                padding: 0 30px;
            }
            span.line {
                width: 200px;
                height: 1.5px;
                background-color: #999;
            }
        }
        .activity-introduce-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            max-width: 1220px;
            min-height: 470px;
            padding: 0 10px;
            word-break: break-all;
            .activity-introduce-content-text {
                width: 100%;
                p {
                    font-size: 24px;
                    padding: 10px;
                    color: #333333;
                    font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
                }
            }
            .prompt {
                width: 100%;
                color: red;
                font-size: 16px;
                text-align: right;
            }
            .text-content {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                min-height: 300px;
                color: #333333;
                margin-top: 100px;
                .text-box {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    color: #333;
                    white-space: nowrap;
                    .title {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        width: 170px;
                        height: 170px;
                        color: #fff;
                        font-size: 14px;
                        border-radius: 50%;
                        background-color: #02A7F0;
                        font-size: 20px;
                        font-weight: 650;
                        margin-bottom: 15px;
                        align-content: flex-start;
                    }
                }
                .text-box.cultivate .title {
                    background-color: #F59A23;
                }
                .text-box.cut-off .title {
                    background-color: #EC808D;
                }
                .text-box.list .title {
                    background-color: #00BFBF;
                }
                
                img {
                    padding: 60px;
                }
            }
        }
    }
    .activity-contest {
        position: relative;
        width: 100%;
        min-height: 800px;
        background-color: rgba(2, 125, 180, 1);
        .activity-contest-title {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            color: #fff;
            padding: 60px 0;
            span {
                font-size: 32px;
                font-weight: 650;
                padding: 0 30px;
            }
            span.line {
                width: 200px;
                height: 1.5px;
                background-color: #fff;
            }
        }
        .activity-contest-content {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            min-height: 680px;
            padding: 10px;
            margin: 0 50px;
            background-color: rgba(242, 242, 242, 1);
            .originality {
                width: 65%;
                h4 {
                    text-align: center;
                    font-size: 24px;
                    font-weight: 650;
                    font-style: normal;
                    letter-spacing: 3px;
                    padding: 30px 0;
                }
                .originality-card-box {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-around;
                    align-items: center;
                    .contest-card {
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        width: 475px;
                        img {
                            width: 100%;
                        }
                        .card-btn-box {
                            position: absolute;
                            bottom: 55px;
                            left: 50%;
                            transform: translateX(-50%);
                            width: 140px;
                            height: 40px;
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            background: inherit;
                            background-color: rgba(245, 154, 35, 1);
                            border: none;
                            box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);
                            color: #fff;
                            border-radius: 16px;
                            cursor: pointer;
                        }
                        .card-type {
                            color: #AAAAAA;
                            font-size: 18px;
                            font-weight: 650;
                            font-style: normal;
                            padding-top: 10px;
                        }
                    }
                }
            }
            .smart {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 35%;
                h4 {
                    text-align: center;
                    font-size: 24px;
                    font-weight: 650;
                    font-style: normal;
                    letter-spacing: 3px;
                    padding: 30px 0;
                }
                .contest-card {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 475px;
                    img {
                        width: 100%;
                    }
                    .card-btn-box {
                        position: absolute;
                        bottom: 55px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 140px;
                        height: 40px;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        background: inherit;
                        background-color: rgba(245, 154, 35, 1);
                        border: none;
                        box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);
                        color: #fff;
                        border-radius: 16px;
                        cursor: pointer;
                    }
                    .card-type {
                        color: #AAAAAA;
                        font-size: 18px;
                        font-weight: 650;
                        font-style: normal;
                        padding-top: 10px;
                    }
                }
            }
        }
    }
    .footer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        min-height: 280px;
        color: #FFFFFF;
        font-size: 14px;
        padding: 70px;
        margin-top: 100px;
        background-color: rgba(51, 51, 51, 1);
        img {
            width: 120px;
            height: 120px;
        }
    }
    @media (max-width: 1740px) {
        .activity-contest {
            .activity-contest-content {
                flex-direction: column;
                .originality,
                .smart {
                    width: 100%;
                }
            }
        }
    }
    @media (max-width: 1450px) {
        .activity-theme {
            .activity-theme-title {
                padding-bottom: 80px;
            }
            .activity-theme-content {
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                .text-content {
                    margin-top: 20px;
                }
            }
        }
    }
    @media (max-width: 1220px) {
        .activity-introduce {
            .activity-introduce-content {
                .text-content {
                    flex-direction: column;
                    flex-wrap: wrap;
                    padding: 20px;
                    img {
                        transform: rotate(90deg);
                    }
                }
            }
            
        }
    }
    @media (max-width: 1010px) {
        .activity-contest {
            .activity-contest-content {
                .originality {
                    .originality-card-box {
                        flex-direction: column;
                    }
                }
            }
        }
        .activity-theme .activity-theme-content .text-content {
            width: 80%;
            min-height: 470px;
        }
    }
    @media (max-width: 750px) {
        .activity-theme {
            .activity-theme-content {
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                .text-content {
                    padding: 20px 30px;
                }
            }
        }
        .footer {
            flex-direction: column;
        }
    }
    @media (max-width: 620px) {
        .activity-theme .activity-theme-title .line,
        .activity-introduce .activity-introduce-title .line,
        .activity-contest .activity-contest-title .line {
            display: none;
        }
        .activity-contest .activity-contest-content .originality .originality-card-box .contest-card,
        .activity-contest .activity-contest-content .smart .contest-card {
            width: 98%;
            .card-btn-box {
                width: 110px;
                height: 30px;
            }
        }
        .activity-introduce .activity-introduce-content {
            padding: 0 10px;
        }
    }
    @media (max-width: 500px) {
        .activity-contest .activity-contest-content {
            margin: 0 5px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/kexie/kexie.vue